import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import "@smartdesign/button";

declare global {
    interface HTMLElementTagNameMap {
        [AppBanner.ID]: AppBanner;
    }
}

@customElement("sd-app-banner")
export class AppBanner extends LitElement {
    public static readonly ID = "sd-app-banner";
    static styles = css`
        p {
            white-space: normal;
            font-size: 0.87em;
            margin-top: 2px;
            margin-bottom: 2px;
            font-weight: 500;
            margin-left: 12px;
        }

        .text-container {
            display: flex;
            flex-direction: column;
        }
        .app-banner {
            background-color: #fff;
            text-align: left;
            margin: 20px;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            border-color: #17202a;
            border-style: solid;
            border-width: 2px;
            display: grid;
            grid-template-columns: auto 1fr auto;
            align-items: center;
        }

        sd-button span {
            font-size: 0.75em;
            font-weight: 500;
            margin-top: 7px;
            text-align: center;
        }

        img {
            margin-left: 5px;
            margin-top: 3px;
            margin-bottom: 3px;
            display: block;
            width: 63px;
        }

        .close-banner {
            display: flex;
            align-items: center;
            margin-left: 3px;
            margin-right: 5px;
            margin-bottom: 1px;
            height: 35px;
        }

        .open-app {
            display: flex;
            align-items: center;
            margin-bottom: 2px;
            padding-bottom: 8px;
            margin-left: 3px;
            margin-right: 5px;
        }
    `;

    @property()
    message = "CAS genesisWorld SmartDesign Mobile App";
    @property()
    messageAppButton = "Open";
    @property()
    messageBrowserButton = "Continue in browser";
    @property()
    url = "";
    @property()
    icon = "";

    render() {
        return html`<div class="app-banner">
            <div class="grid-item">
                <img src="${this.icon}" />
            </div>
            <div class="grid-item">
                <p>${this.message}</p>
            </div>
            <div class="grid-item">
                <sd-button
                    class="close-banner"
                    type="button"
                    id="continue-button"
                    @click="${this.closeBannerAndSetSessionAttribute}"
                    ><span>${this.messageBrowserButton}</span></sd-button
                >
                <sd-button primary class="open-app" type="button" onclick="window.location.href ='${this.url}'"
                    ><span>${this.messageAppButton}</span></sd-button
                >
            </div>
        </div>`;
    }

    closeBannerAndSetSessionAttribute() {
        const element = document.getElementsByTagName("sd-app-banner")[0] as unknown as HTMLElement;
        element.style.display = "none";
    }
}
